import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Repair3Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path d="M31 7.25003H27.25V9.75003H31V7.25003Z" fill="currentColor" />
      <path
        d="M24.484 16.6517L22.5166 18.1922L24.8284 21.1448L26.7958 19.6043L24.484 16.6517Z"
        fill="currentColor"
      />
      <path
        d="M27.0953 12.4443L25.8683 14.6225L29.1367 16.4636L30.3637 14.2854L27.0953 12.4443Z"
        fill="currentColor"
      />
      <path
        d="M8.49125 12.7438L1 27.5763L7.7475 31L15.2387 16.165L8.49125 12.7438Z"
        fill="currentColor"
      />
      <path
        d="M23.125 14.555L25.1038 10.6538C25.7275 9.42503 25.2338 7.91753 24.005 7.29378L13.33 1.87754C9.3375 -0.147454 4.43625 1.45129 2.40875 5.44754L1.8425 6.56254L19.7638 15.6525C20.125 15.835 20.51 15.9225 20.89 15.9225C21.8013 15.9225 22.685 15.4238 23.125 14.555Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
